import { getTestIds } from "../../utils/TestIds";
export const GetTextButtonTID = parentTestId => getTestIds({
  parentTestId,
  deprecatedTestIds: {
    TextButtonTestIds: {
      Wrapper: testid => testid ? "".concat(testid, "-wrapper") : '',
      Tooltip: testid => testid ? "".concat(testid, "-tooltip") : ''
    }
  }
});